"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));
var _addYears = _interopRequireDefault(require("date-fns/addYears"));
var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));
var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));
var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));
var _setMonth2 = _interopRequireDefault(require("date-fns/setMonth"));
var _setYear2 = _interopRequireDefault(require("date-fns/setYear"));
var _min = _interopRequireDefault(require("date-fns/min"));
var _max = _interopRequireDefault(require("date-fns/max"));
var _differenceInCalendarMonths = _interopRequireDefault(require("date-fns/differenceInCalendarMonths"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));
var _ArrowLeftSolidIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/ArrowLeftSolidIcon"));
var _ArrowRightSolidIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/ArrowRightSolidIcon"));
var _ArrowLeftLongIcon = _interopRequireDefault(require("@8x8/oxygen-icon/novo/ArrowLeftLongIcon"));
var _ArrowRightLongIcon = _interopRequireDefault(require("@8x8/oxygen-icon/novo/ArrowRightLongIcon"));
var _oxygenDropdownButton = _interopRequireDefault(require("@8x8/oxygen-dropdown-button"));
var _oxygenList = _interopRequireWildcard(require("@8x8/oxygen-list"));
var _oxygenConfig = require("@8x8/oxygen-config");
var Styled = _interopRequireWildcard(require("../styled/Calendar"));
var _Month = _interopRequireDefault(require("./Month"));
var _constants = _interopRequireDefault(require("../constants"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Calendar = /*#__PURE__*/function (_PureComponent) {
  _inherits(Calendar, _PureComponent);
  var _super = _createSuper(Calendar);
  function Calendar() {
    var _this$props$range;
    var _this;
    _classCallCheck(this, Calendar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      focusedDate: ((_this$props$range = _this.props.range) === null || _this$props$range === void 0 ? void 0 : _this$props$range.startDate) || _this.props.date || _this.props.defaultFocusedDate || new Date(),
      preview: undefined
    });
    _defineProperty(_assertThisInitialized(_this), "onDayClick", function (day) {
      var _this$props = _this.props,
        displayMode = _this$props.displayMode,
        range = _this$props.range,
        onRangeChange = _this$props.onRangeChange,
        onDateChange = _this$props.onDateChange;
      if (displayMode === _constants["default"].DATE) {
        onDateChange(new Date(day));
        return;
      }
      if (!range) {
        onRangeChange({
          startDate: new Date(day)
        });
        return;
      }
      var startDate = range.startDate,
        endDate = range.endDate;
      if (!startDate) {
        onRangeChange({
          startDate: new Date(day)
        });
        return;
      }
      if (!endDate) {
        endDate = new Date(day);
        if ((0, _isBefore["default"])(endDate, startDate)) {
          var _ref = [endDate, startDate];
          startDate = _ref[0];
          endDate = _ref[1];
        }
        _this.setPreviewToDay(day);
        onRangeChange({
          startDate: startDate,
          endDate: endDate
        });
        return;
      }
      onRangeChange({
        startDate: new Date(day)
      });
      _this.setPreviewToDay(day);
    });
    _defineProperty(_assertThisInitialized(_this), "onPreviewChangeCb", function (day) {
      var _this$props2 = _this.props,
        displayMode = _this$props2.displayMode,
        range = _this$props2.range,
        onPreviewChange = _this$props2.onPreviewChange,
        showPreview = _this$props2.showPreview;
      if (!showPreview) {
        return;
      }
      if (!day) {
        var _preview = undefined;
        _this.setState({
          preview: _preview
        });
        onPreviewChange(_preview);
        return;
      }
      if (displayMode === _constants["default"].DATE) {
        var _preview2 = {
          startDate: new Date(day),
          endDate: new Date(day)
        };
        _this.setState({
          preview: _preview2
        });
        onPreviewChange(_preview2);
        return;
      }
      if (!range || !range.startDate) {
        var _preview3 = {
          startDate: new Date(day),
          endDate: new Date(day)
        };
        _this.setState({
          preview: _preview3
        });
        onPreviewChange(_preview3);
        return;
      }
      if (!range.endDate) {
        var _preview4 = {
          startDate: new Date(range.startDate),
          endDate: new Date(day)
        };
        _this.setState({
          preview: _preview4
        });
        onPreviewChange(_preview4);
        return;
      }
      var preview = {
        startDate: new Date(day),
        endDate: new Date(day)
      };
      _this.setState({
        preview: preview
      });
      onPreviewChange(preview);
    });
    _defineProperty(_assertThisInitialized(_this), "setPreviewToDay", function (day) {
      return _this.setState({
        preview: {
          startDate: new Date(day),
          endDate: new Date(day)
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "isMonthPickerOptionDisabled", function (month) {
      var focusedDate = _this.state.focusedDate;
      var _this$props3 = _this.props,
        minDate = _this$props3.minDate,
        maxDate = _this$props3.maxDate;
      var dateWithMonth = (0, _setMonth2["default"])(focusedDate, month);
      return (0, _differenceInCalendarMonths["default"])(dateWithMonth, minDate) < 0 || (0, _differenceInCalendarMonths["default"])(maxDate, dateWithMonth) < 0;
    });
    _defineProperty(_assertThisInitialized(_this), "changeShownDate", function (value) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set';
      var focusedDate = _this.state.focusedDate;
      var _this$props4 = _this.props,
        months = _this$props4.months,
        minDate = _this$props4.minDate,
        maxDate = _this$props4.maxDate;
      var modeMap = {
        monthOffset: function monthOffset() {
          return (0, _addMonths["default"])(focusedDate, value);
        },
        setMonth: function setMonth() {
          return (0, _setMonth2["default"])(focusedDate, value);
        },
        setYear: function setYear() {
          return (0, _setYear2["default"])(focusedDate, value);
        },
        set: function set() {
          return value;
        }
      };
      var newDate = (0, _min["default"])([(0, _max["default"])([modeMap[mode](), minDate]), (0, _addMonths["default"])(maxDate, -months + 1)]);
      _this.setState({
        focusedDate: new Date(newDate)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderMonthYearPickers", (0, _memoizeOne["default"])(function (testId, dateOptions, minDate, maxDate, focusedMonthFormat, focusedYearFormat, focusedDate, locale) {
      var formatOptions = _objectSpread(_objectSpread({}, dateOptions), {}, {
        locale: locale
      });
      var focusedMonth = (0, _format["default"])(focusedDate, focusedMonthFormat, formatOptions);
      var focusedYear = (0, _format["default"])(focusedDate, focusedYearFormat, formatOptions);
      var monthDate = new Date();
      var upperYearLimit = maxDate.getFullYear();
      var lowerYearLimit = minDate.getFullYear();
      var yearDate = new Date();
      return /*#__PURE__*/_react["default"].createElement(Styled.MonthYearPickers, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_MONTH_YEAR_PICKERS")), /*#__PURE__*/_react["default"].createElement(Styled.MonthYearPicker, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_MONTH_PICKER")), /*#__PURE__*/_react["default"].createElement(_oxygenDropdownButton["default"], _extends({
        buttonText: focusedMonth
      }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_MONTH_PICKER_DROPDOWN_BUTTON"))), /*#__PURE__*/_react["default"].createElement(_oxygenList["default"], null, new Array(12).fill(null).map(function (_, i) {
        monthDate = (0, _setMonth2["default"])(monthDate, i);
        return /*#__PURE__*/_react["default"].createElement(_oxygenList.ListItem, _extends({
          key: monthDate.toString(),
          onClick: function onClick() {
            return _this.changeShownDate(i, 'setMonth');
          },
          isDisabled: _this.isMonthPickerOptionDisabled(i)
        }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_MONTH_PICKER_LIST_ITEM_").concat(i))), (0, _format["default"])(monthDate, focusedMonthFormat, formatOptions));
      })))), /*#__PURE__*/_react["default"].createElement(Styled.MonthYearPicker, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_YEAR_PICKER")), /*#__PURE__*/_react["default"].createElement(_oxygenDropdownButton["default"], _extends({
        buttonText: focusedYear
      }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_YEAR_PICKER_DROPDOWN_BUTTON"))), /*#__PURE__*/_react["default"].createElement(_oxygenList["default"], null, new Array(upperYearLimit - lowerYearLimit + 1).fill(upperYearLimit).map(function (val, i) {
        var year = val - i;
        yearDate.setFullYear(year);
        return /*#__PURE__*/_react["default"].createElement(_oxygenList.ListItem, _extends({
          key: year,
          onClick: function onClick() {
            return _this.changeShownDate(year, 'setYear');
          }
        }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_YEAR_PICKER_LIST_ITEM_").concat(year))), (0, _format["default"])(yearDate, focusedYearFormat));
      })))));
    }));
    _defineProperty(_assertThisInitialized(_this), "renderMonthArrows", (0, _memoizeOne["default"])(function (testId, minDate, maxDate, months, showMonthYearPickers, focusedDate, theme) {
      var isPrevDisabled = (0, _differenceInCalendarMonths["default"])(focusedDate, minDate) <= 0;
      var isNextDisabled = (0, _differenceInCalendarMonths["default"])(maxDate, focusedDate) <= months - 1;
      var LeftIcon = theme.isClassic ? _ArrowLeftSolidIcon["default"] : _ArrowLeftLongIcon["default"];
      var RightIcon = theme.isClassic ? _ArrowRightSolidIcon["default"] : _ArrowRightLongIcon["default"];
      var color = theme.arrowColor;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Styled.CalendarMonthNavigation, {
        isLeft: true,
        showMonthYearPickers: showMonthYearPickers && months > 1
      }, /*#__PURE__*/_react["default"].createElement(LeftIcon, _extends({
        link: true,
        disabled: isPrevDisabled,
        onClick: function onClick() {
          return _this.changeShownDate(-1, 'monthOffset');
        },
        color: color
      }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_PREV_MONTH_ARROW"))))), /*#__PURE__*/_react["default"].createElement(Styled.CalendarMonthNavigation, {
        showMonthYearPickers: showMonthYearPickers && months > 1
      }, /*#__PURE__*/_react["default"].createElement(RightIcon, _extends({
        link: true,
        disabled: isNextDisabled,
        onClick: function onClick() {
          return _this.changeShownDate(1, 'monthOffset');
        },
        color: color
      }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_NEXT_MONTH_ARROW"))))));
    }));
    return _this;
  }
  _createClass(Calendar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.checkIfShouldChangePreview(prevProps);
    }
  }, {
    key: "checkIfShouldChangePreview",
    value: function checkIfShouldChangePreview(prevProps) {
      var focusedDate = this.state.focusedDate;
      var _this$props5 = this.props,
        displayMode = _this$props5.displayMode,
        date = _this$props5.date,
        range = _this$props5.range,
        months = _this$props5.months;
      var datesToCheck = [];
      if (displayMode === _constants["default"].DATE && date !== prevProps.date) {
        datesToCheck.push(date);
      } else if (displayMode === _constants["default"].DATE_RANGE && range !== prevProps.range && range !== null && range !== void 0 && range.startDate && range !== null && range !== void 0 && range.endDate) {
        datesToCheck.push(range.startDate, range.endDate);
      }
      if (!datesToCheck.length) {
        return;
      }
      var visibleIntervalStart = (0, _startOfMonth["default"])(focusedDate);
      var visibleIntervalEndDate = (0, _endOfMonth["default"])((0, _addMonths["default"])(focusedDate, months - 1));
      if (datesToCheck.every(function (dateToCheck) {
        return !(0, _isWithinInterval["default"])(dateToCheck, {
          start: visibleIntervalStart,
          end: visibleIntervalEndDate
        });
      })) {
        this.setState({
          focusedDate: datesToCheck[0]
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        focusedDate = _this$state.focusedDate,
        preview = _this$state.preview;
      var _this$props6 = this.props,
        testId = _this$props6.testId,
        showMonthYearPickers = _this$props6.showMonthYearPickers,
        showMonthArrow = _this$props6.showMonthArrow,
        months = _this$props6.months,
        dateOptions = _this$props6.dateOptions,
        minDate = _this$props6.minDate,
        maxDate = _this$props6.maxDate,
        focusedMonthFormat = _this$props6.focusedMonthFormat,
        focusedYearFormat = _this$props6.focusedYearFormat,
        locale = _this$props6.locale,
        theme = _this$props6.theme,
        enableMaxWidth = _this$props6.enableMaxWidth;
      var isClassic = theme.isClassic,
        arrowColor = theme.arrowColor;
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(Styled.CalendarWrapper, (0, _oxygenConfig.getTestAttributes)(testId), showMonthYearPickers && months > 1 && this.renderMonthYearPickers(testId, dateOptions, minDate, maxDate, focusedMonthFormat, focusedYearFormat, focusedDate, locale), showMonthArrow && this.renderMonthArrows(testId, minDate, maxDate, months, showMonthYearPickers, focusedDate, {
        isClassic: isClassic,
        arrowColor: arrowColor
      }), /*#__PURE__*/_react["default"].createElement(Styled.MonthWrapper, {
        enableMaxWidth: enableMaxWidth
      }, new Array(months).fill(null).map(function (_, i) {
        var monthStep = (0, _addMonths["default"])(focusedDate, i);
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: monthStep.toString()
        }, /*#__PURE__*/_react["default"].createElement(_Month["default"], _extends({}, _this2.props, {
          testId: "".concat(testId, "_").concat(i),
          month: monthStep,
          preview: preview,
          showWeekDays: true,
          showMonthName: true,
          locale: locale,
          onDayClick: _this2.onDayClick,
          onPreviewChange: _this2.onPreviewChangeCb
        })), /*#__PURE__*/_react["default"].createElement(Styled.MonthSeparator, null));
      }))));
    }
  }]);
  return Calendar;
}(_react.PureComponent);
Calendar.propTypes = {
  testId: _propTypes["default"].string,
  showMonthArrow: _propTypes["default"].bool,
  showMonthYearPickers: _propTypes["default"].bool,
  months: _propTypes["default"].number,
  dateOptions: _propTypes["default"].object,
  defaultFocusedDate: _propTypes["default"].object,
  disabledDates: _propTypes["default"].array,
  enabledDates: _propTypes["default"].array,
  minDate: _propTypes["default"].object,
  maxDate: _propTypes["default"].object,
  displayMode: _propTypes["default"].oneOf(Object.values(_constants["default"])),
  showPreview: _propTypes["default"].bool,
  dayNumberFormat: _propTypes["default"].string,
  weekDayDisplayFormat: _propTypes["default"].string,
  monthDisplayFormat: _propTypes["default"].string,
  focusedMonthFormat: _propTypes["default"].string,
  focusedYearFormat: _propTypes["default"].string,
  locale: _propTypes["default"].object,
  range: _propTypes["default"].shape({
    startDate: _propTypes["default"].object.isRequired,
    endDate: _propTypes["default"].object
  }),
  onRangeChange: _propTypes["default"].func,
  date: _propTypes["default"].object,
  onDateChange: _propTypes["default"].func,
  onPreviewChange: _propTypes["default"].func,
  theme: _propTypes["default"].object.isRequired,
  enableMaxWidth: _propTypes["default"].bool
};
Calendar.defaultProps = {
  testId: 'CALENDAR',
  showMonthArrow: true,
  showMonthYearPickers: true,
  months: 2,
  dateOptions: {
    weekStartsOn: 0,
    customEvenMonths: false
  },
  defaultFocusedDate: undefined,
  disabledDates: [],
  enabledDates: [],
  minDate: (0, _addYears["default"])(new Date(), -100),
  maxDate: (0, _addYears["default"])(new Date(), 20),
  displayMode: _constants["default"].DATE,
  showPreview: true,
  dayNumberFormat: 'd',
  weekDayDisplayFormat: 'EE',
  monthDisplayFormat: 'MMMM yyyy',
  focusedMonthFormat: 'MMMM',
  focusedYearFormat: 'yyyy',
  locale: undefined,
  range: undefined,
  onRangeChange: _lodash["default"],
  date: undefined,
  onDateChange: _lodash["default"],
  onPreviewChange: _lodash["default"],
  enableMaxWidth: true
};
var _default = (0, _oxygenConfig.withTheme)(Calendar, 'calendar');
exports["default"] = _default;